import React from "react";
import Header from "./Header";
import Menu from "./Menu";
import Footer from "./Footer";

function Sidebar({ logout }) {
  return (
    <div className="sidebar">
      <div className="sidebar-content">
        <Header logout={logout} />
        <Menu />
      </div>
      <Footer />
    </div>
  );
}

export default Sidebar;
